import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface PremiumServicesState {
    shared: boolean;
    shareContent: any;
}
const rawState: PremiumServicesState = {
    shared: false,
    shareContent: null
};

const intialState = fromJS(rawState);

export default function premiumServicesReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.FETCH_SHARE_PREMIUM_SERVICE_SUCCESS:
            return merge(state, fromJS({ shared: true }));
        case Actions.RESET_SHARE_PREMIUM_SERVICE:
            return merge(state, fromJS({ shared: false }));
        case Actions.FETCH_SHARE_URL_CONTENT_SUCCESS:
            return merge(state, fromJS({ shareContent: action.payload.data }));
        default:
            return state;
    }
}
